/**
 * @generated SignedSource<<8e8a6a2bc74d95fd86bf7bb70f163c10>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type QueueSidebarPoolsFragment$data = {
  readonly agentPool: ReadonlyArray<{
    readonly name: string | null | undefined;
    readonly rawId: number | null | undefined;
  }> | null | undefined;
  readonly " $fragmentType": "QueueSidebarPoolsFragment";
};
export type QueueSidebarPoolsFragment$key = {
  readonly " $data"?: QueueSidebarPoolsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"QueueSidebarPoolsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "QueueSidebarPoolsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AgentPoolRest",
      "kind": "LinkedField",
      "name": "agentPool",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rawId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AgentPools",
  "abstractKey": null
};

(node as any).hash = "793534d1f42582a5cd6d7d204c6cdb8b";

export default node;
